import { render, staticRenderFns } from "./ArrobaMedellinVerticalCardNetworking.html?vue&type=template&id=4c80a0d9&scoped=true&external"
import script from "./ArrobaMedellinVerticalCardNetworking.vue?vue&type=script&lang=js"
export * from "./ArrobaMedellinVerticalCardNetworking.vue?vue&type=script&lang=js"
import style0 from "./ArrobaMedellinVerticalCardNetworking.scss?vue&type=style&index=0&id=4c80a0d9&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c80a0d9",
  null
  
)

export default component.exports